module.exports = "<a :href=\"cloneLink\" v-link=\"routerLink\" class=\"weui_cell\" >\n  <cell-header><slot name=\"header\"></slot></cell-header>\n  <cell-body><slot name=\"body\"></slot></cell-body>\n  <cell-footer><slot name=\"footer\"></slot></cell-footer>\n</a>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/link-cell.vue
 ** module id = 73
 ** module chunks = 0
 **/